import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('components.data_table')

type DataTableFooterProps = {
  totalCount: number
  pageSize: number
  currentPage: number
  label?: string
}

export function DataTableFooter({ totalCount, pageSize, currentPage, label = '' }: DataTableFooterProps) {
  if (totalCount === 0) return null

  const start = (currentPage - 1) * pageSize + 1
  const end = Math.min(currentPage * pageSize, totalCount)

  return (
    <div className="tw:px-6 tw:py-4">
      <p className="tw:text-sm tw:text-gray-500">
        {t('footer.showing', { count: end - start + 1, start: String(start), end: String(end), total: String(totalCount), label })}
      </p>
    </div>
  )
}
